import apiClient from './client';

// Authentication
export const login = async (username, password) => {
  const response = await apiClient.post('/auth/login', { username, password });
  return response.data;
};

export const register = async (username, password) => {
  const response = await apiClient.post('/auth/register', { username, password });
  return response.data;
};

// File uploads
export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post('/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadVideo = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post('/upload/video', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

// Products
export const getProducts = async (params = {}) => {
  const response = await apiClient.get('/products', { params });
  return response.data;
};

export const getProduct = async (id) => {
  const response = await apiClient.get(`/products/${id}`);
  return response.data;
};

export const createProduct = async (data) => {
  const response = await apiClient.post('/products', data);
  return response.data;
};

export const updateProduct = async (id, data) => {
  const response = await apiClient.put(`/products/${id}`, data);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await apiClient.delete(`/products/${id}`);
  return response.data;
};

// Streaming Content
export const getStreamingContent = async () => {
  const response = await apiClient.get('/streaming');
  return response.data;
};

export const createStreamingContent = async (data) => {
  const response = await apiClient.post('/streaming', data);
  return response.data;
};

export const updateStreamingContent = async (id, data) => {
  const response = await apiClient.put(`/streaming/${id}`, data);
  return response.data;
};

export const deleteStreamingContent = async (id) => {
  const response = await apiClient.delete(`/streaming/${id}`);
  return response.data;
};

// Hero Section
export const getHero = async () => {
  const response = await apiClient.get('/hero');
  return response.data;
};

export const createOrUpdateHero = async (data) => {
  const response = await apiClient.post('/hero', data);
  return response.data;
};

// Sections
export const getSections = async () => {
  const response = await apiClient.get('/sections');
  return response.data;
};

export const getSection = async (type) => {
  const response = await apiClient.get(`/sections/${type}`);
  return response.data;
};

export const updateSection = async (type, data) => {
  const response = await apiClient.put(`/sections/${type}`, data);
  return response.data;
};